'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BibTitle = require('./components/BibTitle.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BibTitle).default;
  }
});
Object.defineProperty(exports, 'BibTitle', {
  enumerable: true,
  get: function get() {
    return _BibTitle.BibTitle;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-bib-title/lib/index.js
// module id = 1477
// module chunks = 1